import { trackEvent } from 'helpers/analytics';
import { useCallback } from 'react';
import {
  useAddTagToContactsMutation,
  useAddTagToSingleContactMutation,
  useRemoveTagFromContactMutation,
} from 'services/contacts';
import { useCreateTagMutation } from 'services/tags';

export const useAddTagToSingleContacts = ({ queryParams, contact, activeNetwork }) => {
  const [addTagToSingleContacts] = useAddTagToSingleContactMutation();
  const [removeTagFromContact] = useRemoveTagFromContactMutation();
  const [addTagToContacts, { isLoading: isAddingTagToContacts }] = useAddTagToContactsMutation();

  const [createTag, { isLoading: isCreatingTag }] = useCreateTagMutation();
  const onChangeTag = useCallback(
    (tags, opt, checked) => {
      if (checked) {
        addTagToSingleContacts({ contactId: contact.id, tag: tags.find((item) => item.id === opt.value), queryParams });
        trackEvent('contacts:tags:create', {
          collectionId: activeNetwork.id,
          listId: parseInt(queryParams.listId, 10),
          origin: 'contact_card',
        });
      } else {
        removeTagFromContact({ queryParams, tag: { id: opt.value }, contactId: contact.id });
        trackEvent('contacts:tags:delete', {
          collectionId: activeNetwork.id,
          listId: parseInt(queryParams.listId, 10),
          origin: 'contact_card',
        });
      }
    },
    [addTagToSingleContacts, removeTagFromContact, activeNetwork, queryParams, contact],
  );

  const onCreateTag = async (tagName) => {
    const { data } = await createTag({ tagName });

    addTagToContacts({ queryParams, tag: data.tag, contactIds: [contact.id] });
    trackEvent('contacts:tags:create', {
      collectionId: activeNetwork.id,
      listId: parseInt(queryParams.listId, 10),
      origin: 'contact_card',
    });
  };

  return {
    onChangeTag,
    onCreateTag,
    isLoading: isCreatingTag || isAddingTagToContacts,
  };
};
